import React from 'react';
import NewModal from '@/components/NewModal';
import {
    Pad20,
    Fz15Bold,
    Fz18Bold,
    Mb20,
    Mb30,
    PopShortMsg,
    ListCol2,
    BtnHalfModalBlack,
    BtnHalfModal,
    Paragraph,
    BtnCloseModal3,
} from '@/css/style';
import icCloseModal from '@/assets/img/ic_close_modal_gray.svg';

function RoleSelectionModal({ isOpen, onClose, onSelectRole, socialInfo }) {
    const handleSelectUser = () => {
        onSelectRole('user', socialInfo);
    };

    const handleSelectDesigner = () => {
        onSelectRole('designer', socialInfo);
    };

    return (
        <NewModal isOpen={isOpen} contentLabel="역할 선택" ariaHideApp={false}>
            <BtnCloseModal3>
                <img src={icCloseModal} alt="닫기" onClick={onClose} />
            </BtnCloseModal3>
            <Pad20>
                <PopShortMsg>
                    <Mb20>
                        <Fz18Bold>회원 유형을 선택해 주세요</Fz18Bold>
                    </Mb20>
                    <Mb30>
                        <Paragraph $fz="1.154rem">
                            {socialInfo?.name || '회원'}님, 환영합니다!
                            <br />
                            어떤 유형으로 가입하시겠어요?
                        </Paragraph>
                    </Mb30>
                </PopShortMsg>
                <ListCol2>
                    <BtnHalfModalBlack onClick={handleSelectUser}>일반회원</BtnHalfModalBlack>
                    <BtnHalfModal onClick={handleSelectDesigner}>디자이너</BtnHalfModal>
                </ListCol2>
            </Pad20>
        </NewModal>
    );
}

export default RoleSelectionModal;
